import React from "react";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import advancedFormat from "dayjs/plugin/advancedFormat";
import timezone from "dayjs/plugin/timezone";
import Tooltip from "./Tooltip";
import { useTimezone } from "components/TimezoneContextProvider";
import { UTC, getLocalTimezoneName } from "helpers/timezone";

dayjs.extend(utc);
dayjs.extend(advancedFormat);
dayjs.extend(timezone);

const FORMAT = "MMM D, YYYY, h:mm A";

const Timestamp = ({ timestamp }) => {
  const { mode } = useTimezone();
  const utcDate = `${dayjs.utc(timestamp).format(FORMAT)} (UTC)`;
  const timezoneString = getLocalTimezoneName();
  const localDate = `${dayjs(timestamp).local().format(FORMAT)} (${timezoneString})`;

  // The selected zone is shown inline; the other one is in the tooltip.
  const [primary, secondary] =
    mode === UTC ? [utcDate, localDate] : [localDate, utcDate];

  return (
    <Tooltip
      tooltipContent={
        <div className="text-xs">
          <p className="mb-2">{secondary}</p>
          <p>{primary}</p>
        </div>
      }
    >
      <span>{primary}</span>
    </Tooltip>
  );
};

export default Timestamp;
